import { AgentScope } from "src/graphql/types";
import type { AdStudioTemplateCard } from "src/pages/ad-studio/templates/types";

/** Whether the Ads template pickers offer the template, before brand filtering. */
export function isAdTemplateOffered(
  template: Pick<AdStudioTemplateCard, "isActive" | "agentScopes">,
): boolean {
  return (
    template.isActive &&
    (template.agentScopes.length === 0 ||
      template.agentScopes.includes(AgentScope.Ads))
  );
}
